import { render, staticRenderFns } from "./GestioneModuliAziende.vue?vue&type=template&id=6151f8fa&scoped=true&"
import script from "./GestioneModuliAziende.vue?vue&type=script&lang=js&"
export * from "./GestioneModuliAziende.vue?vue&type=script&lang=js&"
import style0 from "./GestioneModuliAziende.vue?vue&type=style&index=0&id=6151f8fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151f8fa",
  null
  
)

export default component.exports